// app/router.options.ts
import type { RouterConfig } from '@nuxt/schema'

// https://router.vuejs.org/api/#scrollbehavior
export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition // geri dönünce eski scroll pozisyonu
    }
    return { top: 0 }
  }
}